import Vue from "vue";
import router from "@/router";
import store from "@/store";
import cookieType from "@/config/cookieType";

const whiteList = []; // no redirect whitelist
const defaultRoutePath = "/";

router.beforeEach((to, from, next) => {
  // console.log('to :>> ', to);
  store.commit(
    "AppSetting/ON_SET_ROUTER_NAME",
    to.meta.title ? to.meta.title : "Miraj Cinemas"
  );

  next();
});

// router.beforeEach((to, from, next) => {
//     if (Vue.cookie.get(cookieType.HASHID)) {
//         /* has token */
//         if (to.path === '/login') {
//             next({ path: defaultRoutePath })
//         } else {
//             next()
//             // if (store.getters.roles.length === 0) {
//             //     next({ ...to })
//             // } else {
//             //     next()
//             // }
//         }
//     } else {
//         if (whiteList.includes(to.name)) {
//             next()
//         } else {
//             next({ path: '/login' })
//         }
//     }
// })

router.afterEach(() => {
  //   Finish
  // if (!Vue.cookie.get(cookieType.CITYID)) {
  //   console.log("SAIFFF");
  //   store.dispatch("onHandleOpenModal", "cityModalModal");
  // }
});



// WEBPACK FOOTER //
// ./src/permissionControl/permission.js